import styled from 'styled-components';

export default styled.div`
	position: fixed;
	left: 215px;
	right: 0;
	height: 100%;
	margin-top: -10px;
	overflow: auto;
`;
